export const getPageCount = (totalItems: number, pageSize: number) => {
  return Math.ceil(totalItems / pageSize)
}

export const getPageOffset = (page: number, limit: number) => {
  return (page - 1) * limit
}

export const MAX_ITEMS_WITHOUT_PAGINATION = 9999
